import * as React from 'react';
import connectWithRouter from '../../../shared/components/redux/connectWithRouter';
import {getItemId, getVariationAspectNames, getVariationProductListingDetailsType} from './ebayListingSelectors';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../../shared/ActionsManager/ActionsTypes';
import {ACTION_DISPLAY_TYPES} from '../../../shared/ActionsManager/ActionsManagerConsts';
import EbayListingsActions from '../../../shared/ActionsManager/EbayListingsActions/EbayListingsActions';
import {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import AddVariationDialog, {
  AddVariationDialogProps,
} from '../../../shared/components/Dialogs/AddVariationDialog/AddVariationDialog';
import {getUnusedListingVariations} from '../../../shared/ActionsManager/EbayListingsActions/EbayListingsActionsSelectors';
import {FIELD_NAMES} from './consts';

interface ListerAddVariationDialogProps extends AddVariationDialogProps {
  itemId?: string[];
  variationProductListingDetailsType: string[];
}

const ListerAddVariationDialog: React.FunctionComponent<SpecificFormDialogProps<{}, ListerAddVariationDialogProps>> = ({
  itemId,
  variationsData,
  variationAspectNames,
  variationProductListingDetailsType,
  columns,
  ...other
}) => {
  return (
    <AddVariationDialog
      columns={columns}
      variationsData={variationsData}
      variationAspectNames={variationAspectNames}
      notMandatoryFields={[...variationProductListingDetailsType, FIELD_NAMES.SKU]}
      actions={
        <EbayListingsActions
          types={[EBAY_LISTINGS_ACTIONS_TYPES.ADD_SINGLE_VARIATION]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          listingsIds={[itemId]}
        />
      }
      formName={EBAY_LISTINGS_ACTIONS_TYPES.ADD_SINGLE_VARIATION}
      {...other}
    />
  );
};

export default connectWithRouter(
  state => ({
    itemId: getItemId(state),
    variationsData: getUnusedListingVariations(state),
    variationAspectNames: getVariationAspectNames(state),
    variationProductListingDetailsType: getVariationProductListingDetailsType(state),
  }),
  {}
)(ListerAddVariationDialog);
